import { render, staticRenderFns } from "./OurMissionPage.vue?vue&type=template&id=05605ad2&scoped=true"
import script from "./OurMissionPage.vue?vue&type=script&lang=ts"
export * from "./OurMissionPage.vue?vue&type=script&lang=ts"
import style0 from "./OurMissionPage.vue?vue&type=style&index=0&id=05605ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05605ad2",
  null
  
)

export default component.exports